// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/full_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIGZpbGw9J25vbmUnIHZpZXdCb3g9JzAgMCAyNCAyNCc+PHBhdGggZmlsbD0nIzBkYTIwYScgZD0nTTEyIDJDNi40OSAyIDIgNi40OSAyIDEyczQuNDkgMTAgMTAgMTAgMTAtNC40OSAxMC0xMFMxNy41MSAyIDEyIDJabTQuNzggNy43LTUuNjcgNS42N2EuNzUuNzUgMCAwIDEtMS4wNiAwbC0yLjgzLTIuODNhLjc1NC43NTQgMCAwIDEgMC0xLjA2Yy4yOS0uMjkuNzctLjI5IDEuMDYgMGwyLjMgMi4zIDUuMTQtNS4xNGMuMjktLjI5Ljc3LS4yOSAxLjA2IDAgLjI5LjI5LjI5Ljc2IDAgMS4wNlonLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saved_card {
    display: block;
    margin-bottom: 0 !important;
}

.saved_card_conteiner {
    min-height: 160px;
    border-radius: 10px;
    border: 1px solid #d8d8d8;
    padding: 20px;
    position: relative;
    cursor: pointer;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
    background-size: cover;
}
.add_card_ {
    min-height: 165px;
    border: 2px dashed #d8d8d8;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 10px;
}
.add_card_:hover {
    border-color: #243977;
    color: #243977;
}
.saved_card_conteiner > * {
    text-align: left;
}
.card_name_ {
    font-size: 14px;
    text-transform: uppercase;
}
.card_number_ {
    font-size: 24px;
    font-weight: 600;
}
.valid_till_label_ {
    font-size: 13px;
    margin-top: 1.5rem;
}
.saved_card_conteiner input[type="radio"] {
    position: absolute;
    width: 0;
    height: 0;
    visibility: hidden;
}
.card_marker {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 16px;
    height: 16px;
    background-color: #dcdcdc;
    border-radius: 50%;
    display: inline-block;
}

.card_marker:after {
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    position: absolute;
    width: 18px;
    height: 18px;
    left: -1px;
    top: -1px;
    opacity: 0;
}
.saved_card_conteiner input[type="radio"]:checked ~ .card_marker {
    background-color: transparent;
}
.saved_card_conteiner input[type="radio"]:checked ~ .card_marker:after {
opacity: 1;
}

.saved_card_slider_ .swiper-pagination {
    position: static !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/update-plan.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,2EAAuE;IACvE,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yDAAue;IACve,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,UAAU;AACd;AACA;IACI,6BAA6B;AACjC;AACA;AACA,UAAU;AACV;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".saved_card {\n    display: block;\n    margin-bottom: 0 !important;\n}\n\n.saved_card_conteiner {\n    min-height: 160px;\n    border-radius: 10px;\n    border: 1px solid #d8d8d8;\n    padding: 20px;\n    position: relative;\n    cursor: pointer;\n    background: url('../assets/images/full_bg.png') center center no-repeat;\n    background-size: cover;\n}\n.add_card_ {\n    min-height: 165px;\n    border: 2px dashed #d8d8d8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    border-radius: 10px;\n}\n.add_card_:hover {\n    border-color: #243977;\n    color: #243977;\n}\n.saved_card_conteiner > * {\n    text-align: left;\n}\n.card_name_ {\n    font-size: 14px;\n    text-transform: uppercase;\n}\n.card_number_ {\n    font-size: 24px;\n    font-weight: 600;\n}\n.valid_till_label_ {\n    font-size: 13px;\n    margin-top: 1.5rem;\n}\n.saved_card_conteiner input[type=\"radio\"] {\n    position: absolute;\n    width: 0;\n    height: 0;\n    visibility: hidden;\n}\n.card_marker {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    width: 16px;\n    height: 16px;\n    background-color: #dcdcdc;\n    border-radius: 50%;\n    display: inline-block;\n}\n\n.card_marker:after {\n    content: \"\";\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIGZpbGw9J25vbmUnIHZpZXdCb3g9JzAgMCAyNCAyNCc+PHBhdGggZmlsbD0nIzBkYTIwYScgZD0nTTEyIDJDNi40OSAyIDIgNi40OSAyIDEyczQuNDkgMTAgMTAgMTAgMTAtNC40OSAxMC0xMFMxNy41MSAyIDEyIDJabTQuNzggNy43LTUuNjcgNS42N2EuNzUuNzUgMCAwIDEtMS4wNiAwbC0yLjgzLTIuODNhLjc1NC43NTQgMCAwIDEgMC0xLjA2Yy4yOS0uMjkuNzctLjI5IDEuMDYgMGwyLjMgMi4zIDUuMTQtNS4xNGMuMjktLjI5Ljc3LS4yOSAxLjA2IDAgLjI5LjI5LjI5Ljc2IDAgMS4wNlonLz48L3N2Zz4=\");\n    position: absolute;\n    width: 18px;\n    height: 18px;\n    left: -1px;\n    top: -1px;\n    opacity: 0;\n}\n.saved_card_conteiner input[type=\"radio\"]:checked ~ .card_marker {\n    background-color: transparent;\n}\n.saved_card_conteiner input[type=\"radio\"]:checked ~ .card_marker:after {\nopacity: 1;\n}\n\n.saved_card_slider_ .swiper-pagination {\n    position: static !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
